@if (isLoading() || (error() && !btService.isConnected())) {
  <div class="flex flex-col items-center justify-center min-h-[200px]">
    @if (isLoading()) {
      <mat-spinner diameter="32" />
      <p class="mt-5">Waiting for device bluetooth connection</p>
    }

    @if (error()) {
      <p>{{ error() }}</p>
      <button
        (click)="pair()"
        matButton
      >
        Retry
        <mat-icon fontIcon="refresh" />
      </button>
    }
  </div>
}

@if (btService.isConnected() && !isLoading()) {
  @for (network of wifiNetworks(); track network.ssid) {
    <div
      class="flex cursor-pointer hover:text-ui-green-light"
      (click)="selectedNetwork.set(network.ssid)"
      [class.text-ui-green-light]="selectedNetwork() === network.ssid"
    >
      <div class="mr-2">
        <ng-container *ngTemplateOutlet="signal; context: { $implicit: network.strength }" />
      </div>

      <p class="flex-1">{{ network.ssid }}</p>

      @if (selectedNetwork() === network.ssid) {
        <i class="icon-check text-ui-green-light text-3xl"></i>
      }
    </div>

    @if (selectedNetwork() === network.ssid) {
      <div class="pl-6">
        <ng-container *ngTemplateOutlet="passwordTemplate" />
      </div>
    }
  }

  <div
    class="flex items-center cursor-pointer hover:text-ui-green-light pl-8"
    (click)="selectedNetwork.set(OTHER)"
    [class.text-ui-green-light]="selectedNetwork() === OTHER"
  >
    <p class="flex-1">Other</p>

    @if (selectedNetwork() === OTHER) {
      <i class="icon-check text-ui-green-light text-3xl"></i>
    }
  </div>

  @if (selectedNetwork() === OTHER) {
    <div class="flex gap-3 pl-6">
      <ng-container *ngTemplateOutlet="ssidTemplate" />
      <ng-container *ngTemplateOutlet="passwordTemplate" />
    </div>
  }

  @if (error()) {
    <mat-error class="mt-3">{{ error() }}</mat-error>
  }
}

<ng-template #ssidTemplate>
  <mat-form-field
    class="input-classic w-full mt-3"
    appearance="outline"
  >
    <input
      (change)="customNetwork.set($any($event.target).value)"
      autocomplete="one-time-code"
      matInput
      placeholder="Enter SSID"
    />
  </mat-form-field>
</ng-template>

<ng-template #passwordTemplate>
  <mat-form-field
    class="input-classic w-full mt-3"
    appearance="outline"
  >
    <input
      type="password"
      (change)="password.set($any($event.target).value)"
      #passwordField
      autocomplete="one-time-code"
      matInput
      placeholder="Enter Password"
    />

    <button
      (click)="passwordField.type = passwordField.type === 'password' ? 'text' : 'password'"
      matSuffix
    >
      <mat-icon
        class="text-[24px] p-0 text-ui-gray-450"
        [fontIcon]="passwordField.type === 'password' ? 'visibility' : 'visibility_off'"
      />
    </button>
  </mat-form-field>
</ng-template>

<ng-template
  #signal
  let-strength
>
  @switch (strength) {
    @case (4) {
      <mat-icon fontIcon="network_wifi_4_bar" />
    }
    @case (3) {
      <mat-icon fontIcon="network_wifi_3_bar" />
    }
    @case (2) {
      <mat-icon fontIcon="network_wifi_2_bar" />
    }
    @case (1) {
      <mat-icon fontIcon="network_wifi_1_bar" />
    }
  }
</ng-template>
